/* eslint-disable react/jsx-no-target-blank */

export const openEmailSendingEditor = ({ subject, body, email }) => {
  const mailtoLink = `mailto:${email || ''}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  const win = window.open(mailtoLink, '_blank');
  win.focus();
};

export const openShareDocumentEmailEditor = ({ companyName, link }) => {
  const subject = `QMAS ${companyName} - Document Share`;
  const tBody = `QMAS ${companyName} has shared a file to you:\n\nDownload Link: ${link}`;
  setTimeout(() => {
    openEmailSendingEditor({ subject, body: tBody });
  }, 100);
};
